module.exports = __webpack_public_path__ + "img/christmas-house-1.b2275592.svg";